import React from 'react';
import { C } from '../../shared/design-tokens.js';

interface Employee {
  nickname?: string;
  first_name?: string;
  last_name?: string;
}

interface Terminal {
  name?: string;
  terminal_name?: string;
  label?: string;
  fedex_code?: string;
  id?: string | number;
}

export function formatDisplayName(employee: Employee | null | undefined): string {
  return `${employee?.nickname || employee?.first_name || '?'} ${employee?.last_name || ''}`.trim();
}

export function terminalLabel(terminal: Terminal | null | undefined): string {
  return terminal?.name || terminal?.terminal_name || terminal?.label || terminal?.fedex_code || String(terminal?.id || 'Unknown terminal');
}

export function statusBadge(status: string | null | undefined): { background: string; color: string } {
  if (status === 'active') return { background: 'rgba(78,205,196,0.12)', color: C.green };
  if (status === 'inactive' || status === 'terminated') return { background: 'rgba(255,107,107,0.12)', color: C.red };
  return { background: 'rgba(255,255,255,0.05)', color: C.textMuted };
}

export const CONTROL_BUTTON: React.CSSProperties = {
  padding: '8px 16px',
  color: C.gold,
  background: C.panelSoft,
  border: '1px solid rgba(201,162,39,0.3)',
  borderRadius: 10,
  cursor: 'pointer',
};
